import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section data-section-id="261314" id="מטפל-סיעודי-ברמת-גן-פתרון-מיידי" className="bg-background text-foreground py-16 md:py-24 lg:py-32 px-4 md:px-8 flex flex-col items-center text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        <Link to="/" className="mb-12 md:mb-16 inline-block">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_logo.png" alt="מטפל סיעודי ברמת גן" className="h-24 md:h-32 w-auto" />
        </Link>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-default text-primary mb-8 font-bold">
          מטפל סיעודי ברמת גן תוך 5 שעות
        </h1>

        <div className="space-y-6 text-base md:text-lg text-foreground/80 max-w-3xl mx-auto mb-10 font-default">
          <p>
            זקוקים לסיוע דחוף? אנו מספקים שירותי <Link to="/CaregiverServicePagesPage" className="text-primary font-semibold underline">מטפל סיעודי בבית</Link> המותאמים אישית לצרכי המשפחה. הצוות המקצועי שלנו ערוך להגיע אליכם במהירות המרבית כדי להעניק שקט נפשי וטיפול מסור.
          </p>
          <p>
            בנוסף לטיפול הביתי, אנו מציעים שירותי <Link to="/CaregiverServicePagesPage2" className="text-primary font-semibold underline">השגחה בבית חולים</Link> עבור יקיריכם, המבטיחים ליווי צמוד ומקצועי בכל רגע נתון. אנו פועלים בפריסה רחבה, כולל שירותי <Link to="/NurseInTelAvivWithinHoursPage" className="text-primary font-semibold underline">מטפל סיעודי בתל אביב</Link>, <Link to="#" className="text-primary font-semibold underline">מטפל סיעודי בירושלים</Link> וכן <Link to="#" className="text-primary font-semibold underline">מטפל סיעודי בחיפה</Link> ובכל אזור המרכז.
          </p>
          <p>
            המומחים שלנו זמינים עבורכם עכשיו לפתרון מיידי ומקצועי.
          </p>
          <p>
            תוכלו למצוא מידע נוסף ועדכונים חשובים <Link to="/ProfessionalBlogPage" className="text-primary font-semibold underline">בבלוג המקצועי שלנו</Link> שיעזור לכם לקבל את ההחלטות הנכונות עבור יקיריכם.
          </p>
        </div>

        <Button size="lg" className="rounded-lg shadow-lg text-lg px-8 py-6 bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
          <Link to="/ContactPage">צרו קשר לפתרון מיידי</Link>
        </Button>
      </div>
    </section>;
}